<template>
  <div class="lotcell-tooltip">
    <span ref="linkRef" class="tooltip-value" v-html="highlight()" />

    <template v-if="isBeloil">
      <div class="tooltip__link">
        Участие в данной закупке осуществляется на площадке <br />
        <a href="https://sapsrm.beloil.by" target="_blank"
          >https://sapsrm.beloil.by</a
        >
      </div>
      <div class="tooltip__link">
        Инструкция для регистрации: <br />
        <a href="https://www.youtube.com/watch?v=w-7lsm1-csY" target="_blank">
          https://www.youtube.com
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { highlightSubstring } from "@/utils/highlightSubstring";
import { exceptionSelectionMixin } from "@/mixins/exceptionSelectionMixin";

export default {
  name: "LotTooltip",
  mixins: [exceptionSelectionMixin],
  props: {
    value: {
      type: [String, Number, Object],
      default: "-",
    },
    row: Object,
  },
  computed: {
    isBeloil() {
      return this.row?.proposalSource === "https://sapsrm.beloil.by";
    },
  },
  methods: {
    highlight() {
      return highlightSubstring(
        this.value?.lotName,
        this.currentTab.searchCriteria.keyWords,
      );
    },
  },
};
</script>

<style scoped lang="less">
.lotcell-tooltip {
  font-family: Roboto, sans-serif;
  color: #f7f7f7;
  padding: 4px 8px;
  line-height: 16px;
  word-break: break-word;
  max-width: 290px;

  .tooltip-value {
    display: block;
    cursor: text;
    user-select: text;

    &::selection {
      background-color: #4766cb;
      color: #fff;
    }
  }

  .tooltip__link {
    color: #ffffff;
    margin-top: 6px;
    padding-top: 5px;
    border-top: 1px solid #9fadb5;

    a {
      color: #f7f7f7;
    }
  }
}
</style>
